<app-closeable-dialog-title
  (maximizedChanged)="toggleMaximize($event)"
  [title]="'Ask ' +  data.paper.title">
</app-closeable-dialog-title>


<mat-dialog-content>
  @if (embeddingCheckLoading()) {
    <app-loading-card
      title="Loading your document">
      <p>We prepare your document. This has to be done once.</p>
      <p>Done close this window!</p>
    </app-loading-card>
  } @else {
    @if (hasEmbedding()) {
      @if (isSmallScreen()) {
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
          <mat-tab label="Chat">
            <app-paper-chat [projectId]="data.paper.projectId"
                            [paperId]="data.paper.id">
            </app-paper-chat>
          </mat-tab>
          <mat-tab label="PDF">
            <div class="pdf-wrapper">
                <ngx-extended-pdf-viewer
                  class="pdf-viewer"
                  [src]="getPDFUrl()!"
                  (pdfLoadingFailed)="pdfLoadingFailed($event)"
                  [textLayer]="true"
                  [height]="'100%'"
                  [showSidebarButton]="false"
                  [customSidebar]="withoutSidebar"
                  [sidebarVisible]="false"
                  (updateFindMatchesCount)="updateFindMatchesCount($event)"
                  [showToolbar]="false">
                </ngx-extended-pdf-viewer>

              @if (totalMatches > 0) {
                <div class="pdf-actions">
                  <button mat-icon-button (click)="findPrevious()">
                    <mat-icon>arrow_back_ios</mat-icon>
                  </button>
                  <span>{{ currentMatchNumber }}/{{ totalMatches }}</span>
                  <button mat-icon-button (click)="findNext()">
                    <mat-icon>arrow_forward_ios</mat-icon>
                  </button>
                </div>
              }
            </div>
          </mat-tab>
        </mat-tab-group>
      } @else {

        <div class="chat-wrapper">
          <div class="pdf-wrapper">
            @defer (when viewInit()) {
              <ngx-extended-pdf-viewer
                class="pdf-viewer"
                [src]="getPDFUrl()!"
                [textLayer]="true"
                [height]="'100%'"
                [showSidebarButton]="false"
                [customSidebar]="withoutSidebar"
                [sidebarVisible]="false"
                (updateFindMatchesCount)="updateFindMatchesCount($event)"
                [showToolbar]="false">
              </ngx-extended-pdf-viewer>
            } @placeholder {
              <div class="loading">
                <mat-progress-spinner
                  class="spinner"
                  mode="indeterminate">
                </mat-progress-spinner>
              </div>
            }
            @if (totalMatches > 0) {
              <div class="pdf-actions">
                <button mat-icon-button (click)="findPrevious()">
                  <mat-icon>arrow_back_ios</mat-icon>
                </button>
                <span>{{ currentMatchNumber }}/{{ totalMatches }}</span>
                <button mat-icon-button (click)="findNext()">
                  <mat-icon>arrow_forward_ios</mat-icon>
                </button>
              </div>
            }
          </div>
          <app-paper-chat [projectId]="data.paper.projectId"
                          [paperId]="data.paper.id">
          </app-paper-chat>
        </div>
      }
    } @else {
      <app-error-card
        oopsError="We can't load your paper, please retry later ..."
      >
      </app-error-card>
    }
  }

  @if (embeddingCheckError(); as error) {
    <app-error-card
      [oopsError]="error | json"
    >
    </app-error-card>
  }
</mat-dialog-content>


<ng-template #withoutSidebar>
  <div id="sidebarContainer" style="top:-1px">
    <pdf-sidebar-content></pdf-sidebar-content>
    <div id="sidebarResizer" class="hidden"></div>
  </div>
</ng-template>
